import { cx } from '@twind/core';
import UnreadMessagesBadge from 'app/components/UnreadMessagesBadge';
import useCustomization from 'app/hooks/useCustomization';
import { AnimatePresence } from 'framer-motion';

import BubbleMessages from './BubbleMessages';
import { type DefaultCtaProps } from './types';

const DefaultCta = ({ messages, isExpanded, onClick, unreadMessageCount }: DefaultCtaProps) => {
  const customization = useCustomization();

  const iconUrl = customization?.open_button_icon || '';
  const iconWidth = customization?.open_button_icon_width || 52;
  const iconHeight = customization?.open_button_icon_height || 52;

  return (
    <button
      id="ostro-webchat-button"
      onClick={onClick}
      className={cx('h-[52px] border-buttonColor border-buttonWidth rounded-md overflow-hidden flex items-stretch')}
    >
      <AnimatePresence mode="wait">
        {isExpanded && (
          <BubbleMessages
            id="ostro-webchat-button-text"
            messages={messages}
          />
        )}
      </AnimatePresence>

      <div className="w-[52px] shrink-0 bg-brand-openButtonBackground flex justify-center items-center">
        <img
          className={`w-[${iconWidth}px] h-[${iconHeight}px]`}
          src={iconUrl}
          alt="open tailor"
        />
      </div>

      {unreadMessageCount > 0 && (
        <UnreadMessagesBadge
          count={unreadMessageCount}
          size="md"
          className="top-[-5px] right-[-5px]"
        />
      )}
    </button>
  );
};

export default DefaultCta;
